<template>
  <div class="contrast-container">
    <div
      class="color-preview"
      :style="{ backgroundColor: selectedColor }"
    />
    <div class="contrast-text">
      <div
        v-if="hasSufficientContrast"
        class="text-center"
      >
        ✓ Gute Kontraste
      </div>
      <div
        v-else
        class="text-center text-body-2 text-red-500"
      >
        ⚠ Kontrast zu niedrig
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedColor: {
      type: String,
      default: '#000000'
    },
    hasSufficientContrast: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.contrast-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-preview {
  width: 192px;
  height: 192px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contrast-text {
  margin-top: 16px;
}
</style>
